import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("beaudoin_cart") || "[]"); }
    catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("beaudoin_cart", JSON.stringify(items)); }, [items]);

  const add = (product, size) => {
    setItems((prev) => {
      const key = `${product.id}-${size || ""}`;
      const existing = prev.find((i) => i.key === key);
      if (existing) return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, {
        key, product_id: product.id, name: product.name, name_fr: product.name_fr,
        price: product.price, image: product.image, size: size || null, quantity: 1,
        shopify_variant_id: product.shopify_variant_id || "",
      }];
    });
    setOpen(true);
  };
  const remove = (key) => setItems((p) => p.filter((i) => i.key !== key));
  const updateQty = (key, qty) => setItems((p) => p.map((i) => i.key === key ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, updateQty, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
